"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _themeConfig = _interopRequireDefault(require("@lyearn-team/theme-config"));

var _classnames = _interopRequireDefault(require("classnames"));

var _IconComplete = _interopRequireDefault(require("../../../../Icons/IconComplete"));

var s = _interopRequireWildcard(require("./styles"));

var _MultiProgressCircle = _interopRequireDefault(require("../../../../MultiProgressCircle/"));

var _DarkText = _interopRequireDefault(require("../../../../DarkText"));

/* eslint-disable react/no-unused-prop-types */
function renderProgress(progress) {
  var isCompleted = parseFloat(progress, 10) === 1;
  var ProgressIcon = isCompleted ? React.createElement(_IconComplete.default, {
    style: {
      fill: _themeConfig.default.color.dark.emerald,
      width: 12,
      height: 12
    }
  }) : React.createElement(_MultiProgressCircle.default, {
    size: "11",
    sections: [{
      progress: progress,
      color: "".concat(_themeConfig.default.color.dark.sapphire)
    }],
    strokeWidth: 10,
    isDark: true
  });
  var textColor = isCompleted ? 'emerald' : 'amethyst';
  return React.createElement("div", {
    className: s.progressWrapper
  }, ProgressIcon, React.createElement(_DarkText.default, {
    fontSize: 10,
    color: textColor,
    className: s.progressText
  }, "".concat(Math.round(parseFloat(progress, 10) * 10000) / 100, "%")));
}

function UserProgress(props) {
  var className = props.className,
      assetProgress = props.assetProgress;
  var cardProgress = assetProgress.cardProgress,
      progressOn = assetProgress.progressOn,
      courseProgress = assetProgress.courseProgress,
      courseName = assetProgress.courseName;

  if ((!cardProgress || cardProgress === '0') && !progressOn) {
    return null;
  }

  return React.createElement("div", {
    className: (0, _classnames.default)(s.progressContainer, className)
  }, React.createElement(_DarkText.default, {
    fontSize: 12,
    color: "silver",
    className: s.progressOnText,
    title: courseName
  }, "C:"), renderProgress(courseProgress), React.createElement("div", {
    className: (0, _classnames.default)(s.marginBetween)
  }), React.createElement(_DarkText.default, {
    fontSize: 12,
    color: "silver",
    className: s.progressOnText
  }, progressOn), renderProgress(cardProgress));
}

UserProgress.defaultProps = {
  progress: 0,
  progressOn: '',
  className: null,
  assetProgress: {
    cardProgress: 0,
    progressOn: '',
    courseProgress: 0,
    courseName: ''
  }
};
UserProgress.propTypes = {
  progress: _propTypes.default.number,
  progressOn: _propTypes.default.string,
  className: _propTypes.default.object,
  assetProgress: _propTypes.default.shape({
    cardProgress: _propTypes.default.number,
    progressOn: _propTypes.default.string,
    courseProgress: _propTypes.default.number,
    courseName: _propTypes.default.string
  })
};
var _default = UserProgress;
exports.default = _default;